import "@involves/violin.css/dist/index.min.css";
import Vue from "vue";
import Vuelidate from "vuelidate";
import VueMultianalytics from "vue-multianalytics";
import VueLogger from "vuejs-logger";
import App from "./App.vue";
import router from "./router";
import store from "@/store";
import i18n from "@/i18n";
import env from "@/env";

Vue.use(Vuelidate);
Vue.use(VueLogger, {
  isEnabled: env.nodeEnv() === "PRODUCTION" ? false : true,
  logLevel: "debug",
  showConsoleColors: true,
});
Vue.use(VueMultianalytics, {
  modules: {
    segment: {
      token: env.segmentKey(),
      debug: env.segmentDebug(),
    },
  },
});
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");